import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-efakture',
  templateUrl: './efakture.component.html',
  styleUrls: ['./efakture.component.scss']
})
export class EfaktureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
